module.exports = __webpack_public_path__ + "img/404-illustration.0a5c4013.svg";